import ApiClient from './ApiClient';


class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }
  index(page = 1, includeSubaccounts = false) {    
    return axios.get(`${this.url}`, { params: { page, page_index: true, include_subaccounts: includeSubaccounts } });
  }
  search(page = 1, search = '', account_id = null, includeSubaccounts = false) {
    let params = `page=${page}`;
    if (search) {
      params = `${params}&q=${search}`;
    }    
    if (includeSubaccounts) {
      params = `${params}&include_subaccounts=true`;
      if (account_id) {
        params = `${params}&account_id=${account_id}`;
      }
    }
    let requestURL = `${this.url}/search?${params}`;
    return axios.get(requestURL);
  }
  deleteFromAccountAndSubaccounts(agentId) {
    return axios.delete(`${this.url}/${agentId}?account_and_subaccounts=true`);
  }
}

export default new Agents();
